/*
 * @Description:
 * @Author: miaomiao
 * @Date: 2021-01-05 13:49:46
 * @LastEditTime: 2023-08-04 13:23:43
 * @LastEditors: zerui.yao
 */
// ie polyfill
import 'babel-polyfill';
import Vue from 'vue';
import * as Sentry from '@sentry/vue';
/* 引用okr选人组件 */
import App from './App.vue';
import router from './router';
import store from './store';
import hasPermission from './utils/hasPermission';
import { created, mounted } from './core/bootstrap';
// 国际化
import i18n from './i18n';
// 各种UI
import UI from './core/use';
/* mock */
if (process.env.VUE_APP_MONITOR_ENV === 'prd') {
  Sentry.init({
    Vue,
    dsn: `${
      process.env.VUE_APP_MONITOR_ENV === 'prd'
        ? 'https://8b8a059cbd9c8191383d1b18d8497e54@sentry.ecarxgroup.com/19'
        : 'https://7269a72ec2bd25240a2fdb99ae19484a@sentry-test.ecarxgroup.com/29'
    }`,
    environment: `${process.env.VUE_APP_MONITOR_ENV === 'prd' ? 'production' : 'test'}`,
    normalizeDepth: 10,
    integrations: [
      new Sentry.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router, {
          routeLabel: 'path',
        }),
      }),
    ],
    tracesSampleRate: Number(`${process.env.VUE_APP_MONITOR_ENV === 'prd' ? 1.0 : 0.5}`),
  });
}

// 加载UI组件
Vue.use(UI);

Vue.config.productionTip = false;
Vue.prototype.hasPerm = hasPermission;

new Vue({
  router,
  store,
  i18n,
  created,
  mounted,
  render: (h) => h(App),
}).$mount('#app');
